// @flow
import { Fragment } from 'react';
import Carousel from '../ImageAndText';

import ExternalElementPopup from '../../popups/ExternalElementPopup';

const eImage = '/images/diamond-education/excellent_cut_diamond.jpg';
const vgImage = '/images/diamond-education/very_good_cut_diamond.jpg';
const gImage = '/images/diamond-education/good_cut_diamond.jpg';
const fImage = '/images/diamond-education/fair_cut_diamond.jpg';
const pImage = '/images/diamond-education/poor_cut_diamond.jpg';

const items = [
  {
    headerText: 'Excellent Cut',
    component: (
      <Fragment>
        Maximum{' '}
        <span
          className="text-link text-underline"
          data-popup="grading-diamond-cut-carousel--fire-1"
          role="button"
          tabIndex="0">
          fire
        </span>{' '}
        and{' '}
        <span
          className="text-link text-underline"
          data-popup="grading-diamond-cut-carousel--brilliance-1"
          role="button"
          tabIndex="0">
          brilliance
        </span>
        .<br />
        Reflects nearly all of the light that enters the diamond, creating
        exceptional sparkle and life. of the diamond.
        <ExternalElementPopup
          name="Fire"
          selector="grading-diamond-cut-carousel--fire-1"
        />
        <ExternalElementPopup
          name="Brilliance"
          selector="grading-diamond-cut-carousel--brilliance-1"
        />
      </Fragment>
    ),
    imageUrl: eImage,
    imageLocation: 'left',
    imageAlt: 'Excellent Diamond Cut',
    imageStyles: {
      marginLeft: 51,
      marginTop: 20,
      height: 99,
      width: 123
    }
  },
  {
    headerText: 'Very Good Cut',
    text: `Properly reflects most of the light that enters the diamond,
      producing superior fire and brilliance. Under normal lighting conditions,
      appears very similar to Excellent Cut, but for a lower price.`,
    imageUrl: vgImage,
    imageLocation: 'left',
    imageAlt: 'Very Good Diamond Cut',
    imageStyles: {
      marginLeft: 51,
      marginTop: 21,
      height: 98,
      width: 123
    }
  },
  {
    headerText: 'Good Cut',
    text: `Reflects a majority of the light that enters the diamond, for an
      above average appearance. An excellent value compared to higher cut
      grades.`,
    imageUrl: gImage,
    imageLocation: 'left',
    imageAlt: 'Good Diamond Cut',
    imageStyles: {
      marginLeft: 51,
      marginTop: 25,
      height: 94,
      width: 123
    }
  },
  {
    headerText: 'Fair Cut',
    text: `Allows much of the light entering the diamond to escape from the
      sides or bottom, reducing perceived fire and brilliance. More acceptable
      in diamonds of less than .75 carats, where differences in sparkle are more
      difficult to perceive.`,
    imageUrl: fImage,
    imageLocation: 'left',
    imageAlt: 'Fair Diamond Cut',
    imageStyles: {
      marginLeft: 51,
      marginTop: 20,
      height: 99,
      width: 123
    }
  },
  {
    headerText: 'Poor Cut',
    text: `Allows most of the light entering the diamond to escape from the
      sides or bottom. The diamond may appear noticeably dull and lifeless, even
      to an untrained eye. Lumera does not offer Poor cut diamonds.`,
    imageUrl: pImage,
    imageLocation: 'left',
    imageAlt: 'Poor Diamond Cut',
    imageStyles: {
      marginLeft: 51,
      marginTop: 43,
      height: 76,
      width: 123
    }
  }
];

const GradingDiamondCut = (props: Object) => {
  return <Carousel {...props} items={items} />;
};

export default GradingDiamondCut;
